/**
 * To add a new error, follow the instructions at
 * https://github.com/wiko-labs/kit/tree/main/packages/errors#adding-a-new-error
 *
 * WARNING:
 *   - Don't change the meaning of an error message.
 */
import {
    WIKO_ERROR__ACCOUNTS__ACCOUNT_NOT_FOUND,
    WIKO_ERROR__ACCOUNTS__EXPECTED_ALL_ACCOUNTS_TO_BE_DECODED,
    WIKO_ERROR__ACCOUNTS__EXPECTED_DECODED_ACCOUNT,
    WIKO_ERROR__ACCOUNTS__FAILED_TO_DECODE_ACCOUNT,
    WIKO_ERROR__ACCOUNTS__ONE_OR_MORE_ACCOUNTS_NOT_FOUND,
    WIKO_ERROR__ADDRESSES__FAILED_TO_FIND_VIABLE_PDA_BUMP_SEED,
    WIKO_ERROR__ADDRESSES__INVALID_BASE58_ENCODED_ADDRESS,
    WIKO_ERROR__ADDRESSES__INVALID_BYTE_LENGTH,
    WIKO_ERROR__ADDRESSES__INVALID_ED25519_PUBLIC_KEY,
    WIKO_ERROR__ADDRESSES__INVALID_SEEDS_POINT_ON_CURVE,
    WIKO_ERROR__ADDRESSES__MALFORMED_PDA,
    WIKO_ERROR__ADDRESSES__MAX_NUMBER_OF_PDA_SEEDS_EXCEEDED,
    WIKO_ERROR__ADDRESSES__MAX_PDA_SEED_LENGTH_EXCEEDED,
    WIKO_ERROR__ADDRESSES__PDA_BUMP_SEED_OUT_OF_RANGE,
    WIKO_ERROR__ADDRESSES__PDA_ENDS_WITH_PDA_MARKER,
    WIKO_ERROR__ADDRESSES__STRING_LENGTH_OUT_OF_RANGE,
    WIKO_ERROR__BLOCK_HEIGHT_EXCEEDED,
    WIKO_ERROR__BLOCKHASH_STRING_LENGTH_OUT_OF_RANGE,
    WIKO_ERROR__CODECS__CANNOT_DECODE_EMPTY_BYTE_ARRAY,
    WIKO_ERROR__CODECS__CANNOT_USE_LEXICAL_VALUES_AS_ENUM_DISCRIMINATORS,
    WIKO_ERROR__CODECS__ENCODED_BYTES_MUST_NOT_INCLUDE_SENTINEL,
    WIKO_ERROR__CODECS__ENCODER_DECODER_FIXED_SIZE_MISMATCH,
    WIKO_ERROR__CODECS__ENCODER_DECODER_MAX_SIZE_MISMATCH,
    WIKO_ERROR__CODECS__ENCODER_DECODER_SIZE_COMPATIBILITY_MISMATCH,
    WIKO_ERROR__CODECS__ENUM_DISCRIMINATOR_OUT_OF_RANGE,
    WIKO_ERROR__CODECS__EXPECTED_FIXED_LENGTH,
    WIKO_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH,
    WIKO_ERROR__CODECS__EXPECTED_VARIABLE_LENGTH,
    WIKO_ERROR__CODECS__EXPECTED_ZERO_VALUE_TO_MATCH_ITEM_FIXED_SIZE,
    WIKO_ERROR__CODECS__INVALID_BYTE_LENGTH,
    WIKO_ERROR__CODECS__INVALID_CONSTANT,
    WIKO_ERROR__CODECS__INVALID_DISCRIMINATED_UNION_VARIANT,
    WIKO_ERROR__CODECS__INVALID_ENUM_VARIANT,
    WIKO_ERROR__CODECS__INVALID_LITERAL_UNION_VARIANT,
    WIKO_ERROR__CODECS__INVALID_NUMBER_OF_ITEMS,
    WIKO_ERROR__CODECS__INVALID_STRING_FOR_BASE,
    WIKO_ERROR__CODECS__LITERAL_UNION_DISCRIMINATOR_OUT_OF_RANGE,
    WIKO_ERROR__CODECS__NUMBER_OUT_OF_RANGE,
    WIKO_ERROR__CODECS__OFFSET_OUT_OF_RANGE,
    WIKO_ERROR__CODECS__SENTINEL_MISSING_IN_DECODED_BYTES,
    WIKO_ERROR__CODECS__UNION_VARIANT_OUT_OF_RANGE,
    WIKO_ERROR__CRYPTO__RANDOM_VALUES_FUNCTION_UNIMPLEMENTED,
    WIKO_ERROR__INSTRUCTION__EXPECTED_TO_HAVE_ACCOUNTS,
    WIKO_ERROR__INSTRUCTION__EXPECTED_TO_HAVE_DATA,
    WIKO_ERROR__INSTRUCTION__PROGRAM_ID_MISMATCH,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_ALREADY_INITIALIZED,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_BORROW_FAILED,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_BORROW_OUTSTANDING,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_DATA_SIZE_CHANGED,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_DATA_TOO_SMALL,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_NOT_EXECUTABLE,
    WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_NOT_RENT_EXEMPT,
    WIKO_ERROR__INSTRUCTION_ERROR__ARITHMETIC_OVERFLOW,
    WIKO_ERROR__INSTRUCTION_ERROR__BORSH_IO_ERROR,
    WIKO_ERROR__INSTRUCTION_ERROR__BUILTIN_PROGRAMS_MUST_CONSUME_COMPUTE_UNITS,
    WIKO_ERROR__INSTRUCTION_ERROR__CALL_DEPTH,
    WIKO_ERROR__INSTRUCTION_ERROR__COMPUTATIONAL_BUDGET_EXCEEDED,
    WIKO_ERROR__INSTRUCTION_ERROR__CUSTOM,
    WIKO_ERROR__INSTRUCTION_ERROR__DUPLICATE_ACCOUNT_INDEX,
    WIKO_ERROR__INSTRUCTION_ERROR__DUPLICATE_ACCOUNT_OUT_OF_SYNC,
    WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_ACCOUNT_NOT_RENT_EXEMPT,
    WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_DATA_MODIFIED,
    WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_LAMPORT_CHANGE,
    WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_MODIFIED,
    WIKO_ERROR__INSTRUCTION_ERROR__EXTERNAL_ACCOUNT_DATA_MODIFIED,
    WIKO_ERROR__INSTRUCTION_ERROR__EXTERNAL_ACCOUNT_LAMPORT_SPEND,
    WIKO_ERROR__INSTRUCTION_ERROR__GENERIC_ERROR,
    WIKO_ERROR__INSTRUCTION_ERROR__ILLEGAL_OWNER,
    WIKO_ERROR__INSTRUCTION_ERROR__IMMUTABLE,
    WIKO_ERROR__INSTRUCTION_ERROR__INCORRECT_AUTHORITY,
    WIKO_ERROR__INSTRUCTION_ERROR__INCORRECT_PROGRAM_ID,
    WIKO_ERROR__INSTRUCTION_ERROR__INSUFFICIENT_FUNDS,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ACCOUNT_DATA,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ACCOUNT_OWNER,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ARGUMENT,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ERROR,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_INSTRUCTION_DATA,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_REALLOC,
    WIKO_ERROR__INSTRUCTION_ERROR__INVALID_SEEDS,
    WIKO_ERROR__INSTRUCTION_ERROR__MAX_ACCOUNTS_DATA_ALLOCATIONS_EXCEEDED,
    WIKO_ERROR__INSTRUCTION_ERROR__MAX_ACCOUNTS_EXCEEDED,
    WIKO_ERROR__INSTRUCTION_ERROR__MAX_INSTRUCTION_TRACE_LENGTH_EXCEEDED,
    WIKO_ERROR__INSTRUCTION_ERROR__MAX_SEED_LENGTH_EXCEEDED,
    WIKO_ERROR__INSTRUCTION_ERROR__MISSING_ACCOUNT,
    WIKO_ERROR__INSTRUCTION_ERROR__MISSING_REQUIRED_SIGNATURE,
    WIKO_ERROR__INSTRUCTION_ERROR__MODIFIED_PROGRAM_ID,
    WIKO_ERROR__INSTRUCTION_ERROR__NOT_ENOUGH_ACCOUNT_KEYS,
    WIKO_ERROR__INSTRUCTION_ERROR__PRIVILEGE_ESCALATION,
    WIKO_ERROR__INSTRUCTION_ERROR__PROGRAM_ENVIRONMENT_SETUP_FAILURE,
    WIKO_ERROR__INSTRUCTION_ERROR__PROGRAM_FAILED_TO_COMPILE,
    WIKO_ERROR__INSTRUCTION_ERROR__PROGRAM_FAILED_TO_COMPLETE,
    WIKO_ERROR__INSTRUCTION_ERROR__READONLY_DATA_MODIFIED,
    WIKO_ERROR__INSTRUCTION_ERROR__READONLY_LAMPORT_CHANGE,
    WIKO_ERROR__INSTRUCTION_ERROR__REENTRANCY_NOT_ALLOWED,
    WIKO_ERROR__INSTRUCTION_ERROR__RENT_EPOCH_MODIFIED,
    WIKO_ERROR__INSTRUCTION_ERROR__UNBALANCED_INSTRUCTION,
    WIKO_ERROR__INSTRUCTION_ERROR__UNINITIALIZED_ACCOUNT,
    WIKO_ERROR__INSTRUCTION_ERROR__UNKNOWN,
    WIKO_ERROR__INSTRUCTION_ERROR__UNSUPPORTED_PROGRAM_ID,
    WIKO_ERROR__INSTRUCTION_ERROR__UNSUPPORTED_SYSVAR,
    WIKO_ERROR__INVALID_BLOCKHASH_BYTE_LENGTH,
    WIKO_ERROR__INVALID_NONCE,
    WIKO_ERROR__INVARIANT_VIOLATION__CACHED_ABORTABLE_ITERABLE_CACHE_ENTRY_MISSING,
    WIKO_ERROR__INVARIANT_VIOLATION__DATA_PUBLISHER_CHANNEL_UNIMPLEMENTED,
    WIKO_ERROR__INVARIANT_VIOLATION__SUBSCRIPTION_ITERATOR_MUST_NOT_POLL_BEFORE_RESOLVING_EXISTING_MESSAGE_PROMISE,
    WIKO_ERROR__INVARIANT_VIOLATION__SUBSCRIPTION_ITERATOR_STATE_MISSING,
    WIKO_ERROR__INVARIANT_VIOLATION__SWITCH_MUST_BE_EXHAUSTIVE,
    WIKO_ERROR__JSON_RPC__INTERNAL_ERROR,
    WIKO_ERROR__JSON_RPC__INVALID_PARAMS,
    WIKO_ERROR__JSON_RPC__INVALID_REQUEST,
    WIKO_ERROR__JSON_RPC__METHOD_NOT_FOUND,
    WIKO_ERROR__JSON_RPC__PARSE_ERROR,
    WIKO_ERROR__JSON_RPC__SCAN_ERROR,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_BLOCK_CLEANED_UP,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_BLOCK_NOT_AVAILABLE,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_NO_SNAPSHOT,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_NODE_UNHEALTHY,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_SLOT_SKIPPED,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE,
    WIKO_ERROR__JSON_RPC__SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION,
    WIKO_ERROR__KEYS__INVALID_KEY_PAIR_BYTE_LENGTH,
    WIKO_ERROR__KEYS__INVALID_PRIVATE_KEY_BYTE_LENGTH,
    WIKO_ERROR__KEYS__INVALID_SIGNATURE_BYTE_LENGTH,
    WIKO_ERROR__KEYS__PUBLIC_KEY_MUST_MATCH_PRIVATE_KEY,
    WIKO_ERROR__KEYS__SIGNATURE_STRING_LENGTH_OUT_OF_RANGE,
    WIKO_ERROR__LAMPORTS_OUT_OF_RANGE,
    WIKO_ERROR__MALFORMED_BIGINT_STRING,
    WIKO_ERROR__MALFORMED_JSON_RPC_ERROR,
    WIKO_ERROR__MALFORMED_NUMBER_STRING,
    WIKO_ERROR__NONCE_ACCOUNT_NOT_FOUND,
    WIKO_ERROR__RPC__API_PLAN_MISSING_FOR_RPC_METHOD,
    WIKO_ERROR__RPC__INTEGER_OVERFLOW,
    WIKO_ERROR__RPC__TRANSPORT_HTTP_ERROR,
    WIKO_ERROR__RPC__TRANSPORT_HTTP_HEADER_FORBIDDEN,
    WIKO_ERROR__RPC_SUBSCRIPTIONS__CANNOT_CREATE_SUBSCRIPTION_PLAN,
    WIKO_ERROR__RPC_SUBSCRIPTIONS__CHANNEL_CLOSED_BEFORE_MESSAGE_BUFFERED,
    WIKO_ERROR__RPC_SUBSCRIPTIONS__CHANNEL_CONNECTION_CLOSED,
    WIKO_ERROR__RPC_SUBSCRIPTIONS__CHANNEL_FAILED_TO_CONNECT,
    WIKO_ERROR__RPC_SUBSCRIPTIONS__EXPECTED_SERVER_SUBSCRIPTION_ID,
    WIKO_ERROR__SIGNER__ADDRESS_CANNOT_HAVE_MULTIPLE_SIGNERS,
    WIKO_ERROR__SIGNER__EXPECTED_KEY_PAIR_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_MESSAGE_MODIFYING_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_MESSAGE_PARTIAL_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_MESSAGE_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_MODIFYING_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_PARTIAL_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_SENDING_SIGNER,
    WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_SIGNER,
    WIKO_ERROR__SIGNER__TRANSACTION_CANNOT_HAVE_MULTIPLE_SENDING_SIGNERS,
    WIKO_ERROR__SIGNER__TRANSACTION_SENDING_SIGNER_MISSING,
    WIKO_ERROR__SIGNER__WALLET_MULTISIGN_UNIMPLEMENTED,
    WIKO_ERROR__SUBTLE_CRYPTO__CANNOT_EXPORT_NON_EXTRACTABLE_KEY,
    WIKO_ERROR__SUBTLE_CRYPTO__DIGEST_UNIMPLEMENTED,
    WIKO_ERROR__SUBTLE_CRYPTO__DISALLOWED_IN_INSECURE_CONTEXT,
    WIKO_ERROR__SUBTLE_CRYPTO__ED25519_ALGORITHM_UNIMPLEMENTED,
    WIKO_ERROR__SUBTLE_CRYPTO__EXPORT_FUNCTION_UNIMPLEMENTED,
    WIKO_ERROR__SUBTLE_CRYPTO__GENERATE_FUNCTION_UNIMPLEMENTED,
    WIKO_ERROR__SUBTLE_CRYPTO__SIGN_FUNCTION_UNIMPLEMENTED,
    WIKO_ERROR__SUBTLE_CRYPTO__VERIFY_FUNCTION_UNIMPLEMENTED,
    WIKO_ERROR__TIMESTAMP_OUT_OF_RANGE,
    WIKO_ERROR__TRANSACTION__ADDRESS_MISSING,
    WIKO_ERROR__TRANSACTION__ADDRESSES_CANNOT_SIGN_TRANSACTION,
    WIKO_ERROR__TRANSACTION__CANNOT_ENCODE_WITH_EMPTY_SIGNATURES,
    WIKO_ERROR__TRANSACTION__EXPECTED_BLOCKHASH_LIFETIME,
    WIKO_ERROR__TRANSACTION__EXPECTED_NONCE_LIFETIME,
    WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_ADDRESS_LOOKUP_TABLE_CONTENTS_MISSING,
    WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_ADDRESS_LOOKUP_TABLE_INDEX_OUT_OF_RANGE,
    WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_FEE_PAYER_MISSING,
    WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_INSTRUCTION_PROGRAM_ADDRESS_NOT_FOUND,
    WIKO_ERROR__TRANSACTION__FAILED_TO_ESTIMATE_COMPUTE_LIMIT,
    WIKO_ERROR__TRANSACTION__FAILED_WHEN_SIMULATING_TO_ESTIMATE_COMPUTE_LIMIT,
    WIKO_ERROR__TRANSACTION__FEE_PAYER_MISSING,
    WIKO_ERROR__TRANSACTION__FEE_PAYER_SIGNATURE_MISSING,
    WIKO_ERROR__TRANSACTION__INVALID_NONCE_TRANSACTION_FIRST_INSTRUCTION_MUST_BE_ADVANCE_NONCE,
    WIKO_ERROR__TRANSACTION__INVALID_NONCE_TRANSACTION_INSTRUCTIONS_MISSING,
    WIKO_ERROR__TRANSACTION__INVOKED_PROGRAMS_CANNOT_PAY_FEES,
    WIKO_ERROR__TRANSACTION__INVOKED_PROGRAMS_MUST_NOT_BE_WRITABLE,
    WIKO_ERROR__TRANSACTION__MESSAGE_SIGNATURES_MISMATCH,
    WIKO_ERROR__TRANSACTION__SIGNATURES_MISSING,
    WIKO_ERROR__TRANSACTION__VERSION_NUMBER_OUT_OF_RANGE,
    WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_BORROW_OUTSTANDING,
    WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_IN_USE,
    WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_LOADED_TWICE,
    WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_NOT_FOUND,
    WIKO_ERROR__TRANSACTION_ERROR__ADDRESS_LOOKUP_TABLE_NOT_FOUND,
    WIKO_ERROR__TRANSACTION_ERROR__ALREADY_PROCESSED,
    WIKO_ERROR__TRANSACTION_ERROR__BLOCKHASH_NOT_FOUND,
    WIKO_ERROR__TRANSACTION_ERROR__CALL_CHAIN_TOO_DEEP,
    WIKO_ERROR__TRANSACTION_ERROR__CLUSTER_MAINTENANCE,
    WIKO_ERROR__TRANSACTION_ERROR__DUPLICATE_INSTRUCTION,
    WIKO_ERROR__TRANSACTION_ERROR__INSUFFICIENT_FUNDS_FOR_FEE,
    WIKO_ERROR__TRANSACTION_ERROR__INSUFFICIENT_FUNDS_FOR_RENT,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_ACCOUNT_FOR_FEE,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_ACCOUNT_INDEX,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_ADDRESS_LOOKUP_TABLE_DATA,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_ADDRESS_LOOKUP_TABLE_INDEX,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_ADDRESS_LOOKUP_TABLE_OWNER,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_LOADED_ACCOUNTS_DATA_SIZE_LIMIT,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_PROGRAM_FOR_EXECUTION,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_RENT_PAYING_ACCOUNT,
    WIKO_ERROR__TRANSACTION_ERROR__INVALID_WRITABLE_ACCOUNT,
    WIKO_ERROR__TRANSACTION_ERROR__MAX_LOADED_ACCOUNTS_DATA_SIZE_EXCEEDED,
    WIKO_ERROR__TRANSACTION_ERROR__MISSING_SIGNATURE_FOR_FEE,
    WIKO_ERROR__TRANSACTION_ERROR__PROGRAM_ACCOUNT_NOT_FOUND,
    WIKO_ERROR__TRANSACTION_ERROR__PROGRAM_EXECUTION_TEMPORARILY_RESTRICTED,
    WIKO_ERROR__TRANSACTION_ERROR__RESANITIZATION_NEEDED,
    WIKO_ERROR__TRANSACTION_ERROR__SANITIZE_FAILURE,
    WIKO_ERROR__TRANSACTION_ERROR__SIGNATURE_FAILURE,
    WIKO_ERROR__TRANSACTION_ERROR__TOO_MANY_ACCOUNT_LOCKS,
    WIKO_ERROR__TRANSACTION_ERROR__UNBALANCED_TRANSACTION,
    WIKO_ERROR__TRANSACTION_ERROR__UNKNOWN,
    WIKO_ERROR__TRANSACTION_ERROR__UNSUPPORTED_VERSION,
    WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_ACCOUNT_DATA_BLOCK_LIMIT,
    WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_ACCOUNT_DATA_TOTAL_LIMIT,
    WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_MAX_ACCOUNT_COST_LIMIT,
    WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_MAX_BLOCK_COST_LIMIT,
    WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_MAX_VOTE_COST_LIMIT,
    WikoErrorCode,
} from './codes';

/**
 * A map of every {@link WikoError} code to the error message shown to developers in development
 * mode.
 */
export const WikoErrorMessages: Readonly<{
    // This type makes this data structure exhaustive with respect to `WikoErrorCode`.
    // TypeScript will fail to build this project if add an error code without a message.
    [P in WikoErrorCode]: string;
}> = {
    [WIKO_ERROR__ACCOUNTS__ACCOUNT_NOT_FOUND]: 'Account not found at address: $address',
    [WIKO_ERROR__ACCOUNTS__EXPECTED_ALL_ACCOUNTS_TO_BE_DECODED]:
        'Not all accounts were decoded. Encoded accounts found at addresses: $addresses.',
    [WIKO_ERROR__ACCOUNTS__EXPECTED_DECODED_ACCOUNT]: 'Expected decoded account at address: $address',
    [WIKO_ERROR__ACCOUNTS__FAILED_TO_DECODE_ACCOUNT]: 'Failed to decode account data at address: $address',
    [WIKO_ERROR__ACCOUNTS__ONE_OR_MORE_ACCOUNTS_NOT_FOUND]: 'Accounts not found at addresses: $addresses',
    [WIKO_ERROR__ADDRESSES__FAILED_TO_FIND_VIABLE_PDA_BUMP_SEED]: 'Unable to find a viable program address bump seed.',
    [WIKO_ERROR__ADDRESSES__INVALID_BASE58_ENCODED_ADDRESS]: '$putativeAddress is not a base58-encoded address.',
    [WIKO_ERROR__ADDRESSES__INVALID_BYTE_LENGTH]:
        'Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.',
    [WIKO_ERROR__ADDRESSES__INVALID_ED25519_PUBLIC_KEY]: 'The `CryptoKey` must be an `Ed25519` public key.',
    [WIKO_ERROR__ADDRESSES__INVALID_SEEDS_POINT_ON_CURVE]: 'Invalid seeds; point must fall off the Ed25519 curve.',
    [WIKO_ERROR__ADDRESSES__MALFORMED_PDA]:
        'Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].',
    [WIKO_ERROR__ADDRESSES__MAX_NUMBER_OF_PDA_SEEDS_EXCEEDED]:
        'A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.',
    [WIKO_ERROR__ADDRESSES__MAX_PDA_SEED_LENGTH_EXCEEDED]:
        'The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.',
    [WIKO_ERROR__ADDRESSES__PDA_BUMP_SEED_OUT_OF_RANGE]:
        'Expected program derived address bump to be in the range [0, 255], got: $bump.',
    [WIKO_ERROR__ADDRESSES__PDA_ENDS_WITH_PDA_MARKER]: 'Program address cannot end with PDA marker.',
    [WIKO_ERROR__ADDRESSES__STRING_LENGTH_OUT_OF_RANGE]:
        'Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.',
    [WIKO_ERROR__BLOCKHASH_STRING_LENGTH_OUT_OF_RANGE]:
        'Expected base58-encoded blockash string of length in the range [32, 44]. Actual length: $actualLength.',
    [WIKO_ERROR__BLOCK_HEIGHT_EXCEEDED]:
        'The network has progressed past the last block for which this transaction could have been committed.',
    [WIKO_ERROR__CODECS__CANNOT_DECODE_EMPTY_BYTE_ARRAY]: 'Codec [$codecDescription] cannot decode empty byte arrays.',
    [WIKO_ERROR__CODECS__CANNOT_USE_LEXICAL_VALUES_AS_ENUM_DISCRIMINATORS]:
        'Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`.',
    [WIKO_ERROR__CODECS__ENCODED_BYTES_MUST_NOT_INCLUDE_SENTINEL]:
        'Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes].',
    [WIKO_ERROR__CODECS__ENCODER_DECODER_FIXED_SIZE_MISMATCH]:
        'Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].',
    [WIKO_ERROR__CODECS__ENCODER_DECODER_MAX_SIZE_MISMATCH]:
        'Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].',
    [WIKO_ERROR__CODECS__ENCODER_DECODER_SIZE_COMPATIBILITY_MISMATCH]:
        'Encoder and decoder must either both be fixed-size or variable-size.',
    [WIKO_ERROR__CODECS__ENUM_DISCRIMINATOR_OUT_OF_RANGE]:
        'Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator.',
    [WIKO_ERROR__CODECS__EXPECTED_FIXED_LENGTH]: 'Expected a fixed-size codec, got a variable-size one.',
    [WIKO_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH]:
        'Codec [$codecDescription] expected a positive byte length, got $bytesLength.',
    [WIKO_ERROR__CODECS__EXPECTED_VARIABLE_LENGTH]: 'Expected a variable-size codec, got a fixed-size one.',
    [WIKO_ERROR__CODECS__EXPECTED_ZERO_VALUE_TO_MATCH_ITEM_FIXED_SIZE]:
        'Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes].',
    [WIKO_ERROR__CODECS__INVALID_BYTE_LENGTH]: 'Codec [$codecDescription] expected $expected bytes, got $bytesLength.',
    [WIKO_ERROR__CODECS__INVALID_CONSTANT]:
        'Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset].',
    [WIKO_ERROR__CODECS__INVALID_DISCRIMINATED_UNION_VARIANT]:
        'Invalid discriminated union variant. Expected one of [$variants], got $value.',
    [WIKO_ERROR__CODECS__INVALID_ENUM_VARIANT]:
        'Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant.',
    [WIKO_ERROR__CODECS__INVALID_LITERAL_UNION_VARIANT]:
        'Invalid literal union variant. Expected one of [$variants], got $value.',
    [WIKO_ERROR__CODECS__INVALID_NUMBER_OF_ITEMS]: 'Expected [$codecDescription] to have $expected items, got $actual.',
    [WIKO_ERROR__CODECS__INVALID_STRING_FOR_BASE]: 'Invalid value $value for base $base with alphabet $alphabet.',
    [WIKO_ERROR__CODECS__LITERAL_UNION_DISCRIMINATOR_OUT_OF_RANGE]:
        'Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.',
    [WIKO_ERROR__CODECS__NUMBER_OUT_OF_RANGE]:
        'Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.',
    [WIKO_ERROR__CODECS__OFFSET_OUT_OF_RANGE]:
        'Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.',
    [WIKO_ERROR__CODECS__SENTINEL_MISSING_IN_DECODED_BYTES]:
        'Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes].',
    [WIKO_ERROR__CODECS__UNION_VARIANT_OUT_OF_RANGE]:
        'Union variant out of range. Expected an index between $minRange and $maxRange, got $variant.',
    [WIKO_ERROR__CRYPTO__RANDOM_VALUES_FUNCTION_UNIMPLEMENTED]: 'No random values implementation could be found.',
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_ALREADY_INITIALIZED]: 'instruction requires an uninitialized account',
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_BORROW_FAILED]:
        'instruction tries to borrow reference for an account which is already borrowed',
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_BORROW_OUTSTANDING]:
        'instruction left account with an outstanding borrowed reference',
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_DATA_SIZE_CHANGED]:
        "program other than the account's owner changed the size of the account data",
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_DATA_TOO_SMALL]: 'account data too small for instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_NOT_EXECUTABLE]: 'instruction expected an executable account',
    [WIKO_ERROR__INSTRUCTION_ERROR__ACCOUNT_NOT_RENT_EXEMPT]:
        'An account does not have enough lamports to be rent-exempt',
    [WIKO_ERROR__INSTRUCTION_ERROR__ARITHMETIC_OVERFLOW]: 'Program arithmetic overflowed',
    [WIKO_ERROR__INSTRUCTION_ERROR__BORSH_IO_ERROR]: 'Failed to serialize or deserialize account data: $encodedData',
    [WIKO_ERROR__INSTRUCTION_ERROR__BUILTIN_PROGRAMS_MUST_CONSUME_COMPUTE_UNITS]:
        'Builtin programs must consume compute units',
    [WIKO_ERROR__INSTRUCTION_ERROR__CALL_DEPTH]: 'Cross-program invocation call depth too deep',
    [WIKO_ERROR__INSTRUCTION_ERROR__COMPUTATIONAL_BUDGET_EXCEEDED]: 'Computational budget exceeded',
    [WIKO_ERROR__INSTRUCTION_ERROR__CUSTOM]: 'custom program error: #$code',
    [WIKO_ERROR__INSTRUCTION_ERROR__DUPLICATE_ACCOUNT_INDEX]: 'instruction contains duplicate accounts',
    [WIKO_ERROR__INSTRUCTION_ERROR__DUPLICATE_ACCOUNT_OUT_OF_SYNC]:
        'instruction modifications of multiply-passed account differ',
    [WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_ACCOUNT_NOT_RENT_EXEMPT]: 'executable accounts must be rent exempt',
    [WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_DATA_MODIFIED]: 'instruction changed executable accounts data',
    [WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_LAMPORT_CHANGE]:
        'instruction changed the balance of an executable account',
    [WIKO_ERROR__INSTRUCTION_ERROR__EXECUTABLE_MODIFIED]: 'instruction changed executable bit of an account',
    [WIKO_ERROR__INSTRUCTION_ERROR__EXTERNAL_ACCOUNT_DATA_MODIFIED]:
        'instruction modified data of an account it does not own',
    [WIKO_ERROR__INSTRUCTION_ERROR__EXTERNAL_ACCOUNT_LAMPORT_SPEND]:
        'instruction spent from the balance of an account it does not own',
    [WIKO_ERROR__INSTRUCTION_ERROR__GENERIC_ERROR]: 'generic instruction error',
    [WIKO_ERROR__INSTRUCTION_ERROR__ILLEGAL_OWNER]: 'Provided owner is not allowed',
    [WIKO_ERROR__INSTRUCTION_ERROR__IMMUTABLE]: 'Account is immutable',
    [WIKO_ERROR__INSTRUCTION_ERROR__INCORRECT_AUTHORITY]: 'Incorrect authority provided',
    [WIKO_ERROR__INSTRUCTION_ERROR__INCORRECT_PROGRAM_ID]: 'incorrect program id for instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__INSUFFICIENT_FUNDS]: 'insufficient funds for instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ACCOUNT_DATA]: 'invalid account data for instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ACCOUNT_OWNER]: 'Invalid account owner',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ARGUMENT]: 'invalid program argument',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_ERROR]: 'program returned invalid error code',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_INSTRUCTION_DATA]: 'invalid instruction data',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_REALLOC]: 'Failed to reallocate account data',
    [WIKO_ERROR__INSTRUCTION_ERROR__INVALID_SEEDS]: 'Provided seeds do not result in a valid address',
    [WIKO_ERROR__INSTRUCTION_ERROR__MAX_ACCOUNTS_DATA_ALLOCATIONS_EXCEEDED]:
        'Accounts data allocations exceeded the maximum allowed per transaction',
    [WIKO_ERROR__INSTRUCTION_ERROR__MAX_ACCOUNTS_EXCEEDED]: 'Max accounts exceeded',
    [WIKO_ERROR__INSTRUCTION_ERROR__MAX_INSTRUCTION_TRACE_LENGTH_EXCEEDED]: 'Max instruction trace length exceeded',
    [WIKO_ERROR__INSTRUCTION_ERROR__MAX_SEED_LENGTH_EXCEEDED]: 'Length of the seed is too long for address generation',
    [WIKO_ERROR__INSTRUCTION_ERROR__MISSING_ACCOUNT]: 'An account required by the instruction is missing',
    [WIKO_ERROR__INSTRUCTION_ERROR__MISSING_REQUIRED_SIGNATURE]: 'missing required signature for instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__MODIFIED_PROGRAM_ID]: 'instruction illegally modified the program id of an account',
    [WIKO_ERROR__INSTRUCTION_ERROR__NOT_ENOUGH_ACCOUNT_KEYS]: 'insufficient account keys for instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__PRIVILEGE_ESCALATION]:
        'Cross-program invocation with unauthorized signer or writable account',
    [WIKO_ERROR__INSTRUCTION_ERROR__PROGRAM_ENVIRONMENT_SETUP_FAILURE]:
        'Failed to create program execution environment',
    [WIKO_ERROR__INSTRUCTION_ERROR__PROGRAM_FAILED_TO_COMPILE]: 'Program failed to compile',
    [WIKO_ERROR__INSTRUCTION_ERROR__PROGRAM_FAILED_TO_COMPLETE]: 'Program failed to complete',
    [WIKO_ERROR__INSTRUCTION_ERROR__READONLY_DATA_MODIFIED]: 'instruction modified data of a read-only account',
    [WIKO_ERROR__INSTRUCTION_ERROR__READONLY_LAMPORT_CHANGE]: 'instruction changed the balance of a read-only account',
    [WIKO_ERROR__INSTRUCTION_ERROR__REENTRANCY_NOT_ALLOWED]:
        'Cross-program invocation reentrancy not allowed for this instruction',
    [WIKO_ERROR__INSTRUCTION_ERROR__RENT_EPOCH_MODIFIED]: 'instruction modified rent epoch of an account',
    [WIKO_ERROR__INSTRUCTION_ERROR__UNBALANCED_INSTRUCTION]:
        'sum of account balances before and after instruction do not match',
    [WIKO_ERROR__INSTRUCTION_ERROR__UNINITIALIZED_ACCOUNT]: 'instruction requires an initialized account',
    [WIKO_ERROR__INSTRUCTION_ERROR__UNKNOWN]: '',
    [WIKO_ERROR__INSTRUCTION_ERROR__UNSUPPORTED_PROGRAM_ID]: 'Unsupported program id',
    [WIKO_ERROR__INSTRUCTION_ERROR__UNSUPPORTED_SYSVAR]: 'Unsupported sysvar',
    [WIKO_ERROR__INSTRUCTION__EXPECTED_TO_HAVE_ACCOUNTS]: 'The instruction does not have any accounts.',
    [WIKO_ERROR__INSTRUCTION__EXPECTED_TO_HAVE_DATA]: 'The instruction does not have any data.',
    [WIKO_ERROR__INSTRUCTION__PROGRAM_ID_MISMATCH]:
        'Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.',
    [WIKO_ERROR__INVALID_BLOCKHASH_BYTE_LENGTH]:
        'Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.',
    [WIKO_ERROR__INVALID_NONCE]:
        'The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`',
    [WIKO_ERROR__INVARIANT_VIOLATION__CACHED_ABORTABLE_ITERABLE_CACHE_ENTRY_MISSING]:
        'Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It ' +
        'should be impossible to hit this error; please file an issue at ' +
        'https://sola.na/web3invariant',
    [WIKO_ERROR__INVARIANT_VIOLATION__DATA_PUBLISHER_CHANNEL_UNIMPLEMENTED]:
        'Invariant violation: This data publisher does not publish to the channel named ' +
        '`$channelName`. Supported channels include $supportedChannelNames.',
    [WIKO_ERROR__INVARIANT_VIOLATION__SUBSCRIPTION_ITERATOR_MUST_NOT_POLL_BEFORE_RESOLVING_EXISTING_MESSAGE_PROMISE]:
        'Invariant violation: WebSocket message iterator state is corrupt; iterated without first ' +
        'resolving existing message promise. It should be impossible to hit this error; please ' +
        'file an issue at https://sola.na/web3invariant',
    [WIKO_ERROR__INVARIANT_VIOLATION__SUBSCRIPTION_ITERATOR_STATE_MISSING]:
        'Invariant violation: WebSocket message iterator is missing state storage. It should be ' +
        'impossible to hit this error; please file an issue at https://sola.na/web3invariant',
    [WIKO_ERROR__INVARIANT_VIOLATION__SWITCH_MUST_BE_EXHAUSTIVE]:
        'Invariant violation: Switch statement non-exhaustive. Received unexpected value ' +
        '`$unexpectedValue`. It should be impossible to hit this error; please file an issue at ' +
        'https://sola.na/web3invariant',
    [WIKO_ERROR__JSON_RPC__INTERNAL_ERROR]: 'JSON-RPC error: Internal JSON-RPC error ($__serverMessage)',
    [WIKO_ERROR__JSON_RPC__INVALID_PARAMS]: 'JSON-RPC error: Invalid method parameter(s) ($__serverMessage)',
    [WIKO_ERROR__JSON_RPC__INVALID_REQUEST]:
        'JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)',
    [WIKO_ERROR__JSON_RPC__METHOD_NOT_FOUND]:
        'JSON-RPC error: The method does not exist / is not available ($__serverMessage)',
    [WIKO_ERROR__JSON_RPC__PARSE_ERROR]:
        'JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)',
    [WIKO_ERROR__JSON_RPC__SCAN_ERROR]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_BLOCK_CLEANED_UP]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_BLOCK_NOT_AVAILABLE]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED]: 'Minimum context slot has not been reached',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_NODE_UNHEALTHY]: 'Node is unhealthy; behind by $numSlotsBehind slots',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_NO_SNAPSHOT]: 'No snapshot',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE]: 'Transaction simulation failed',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_SLOT_SKIPPED]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE]:
        'Transaction history is not available from this node',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE]: '$__serverMessage',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH]: 'Transaction signature length mismatch',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE]:
        'Transaction signature verification failure',
    [WIKO_ERROR__JSON_RPC__SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION]: '$__serverMessage',
    [WIKO_ERROR__KEYS__INVALID_KEY_PAIR_BYTE_LENGTH]: 'Key pair bytes must be of length 64, got $byteLength.',
    [WIKO_ERROR__KEYS__INVALID_PRIVATE_KEY_BYTE_LENGTH]:
        'Expected private key bytes with length 32. Actual length: $actualLength.',
    [WIKO_ERROR__KEYS__INVALID_SIGNATURE_BYTE_LENGTH]:
        'Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.',
    [WIKO_ERROR__KEYS__PUBLIC_KEY_MUST_MATCH_PRIVATE_KEY]:
        'The provided private key does not match the provided public key.',
    [WIKO_ERROR__KEYS__SIGNATURE_STRING_LENGTH_OUT_OF_RANGE]:
        'Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.',
    [WIKO_ERROR__LAMPORTS_OUT_OF_RANGE]: 'Lamports value must be in the range [0, 2e64-1]',
    [WIKO_ERROR__MALFORMED_BIGINT_STRING]: '`$value` cannot be parsed as a `BigInt`',
    [WIKO_ERROR__MALFORMED_JSON_RPC_ERROR]: '$message',
    [WIKO_ERROR__MALFORMED_NUMBER_STRING]: '`$value` cannot be parsed as a `Number`',
    [WIKO_ERROR__NONCE_ACCOUNT_NOT_FOUND]: 'No nonce account could be found at address `$nonceAccountAddress`',
    [WIKO_ERROR__RPC_SUBSCRIPTIONS__CANNOT_CREATE_SUBSCRIPTION_PLAN]:
        "The notification name must end in 'Notifications' and the API must supply a " +
        "subscription plan creator function for the notification '$notificationName'.",
    [WIKO_ERROR__RPC_SUBSCRIPTIONS__CHANNEL_CLOSED_BEFORE_MESSAGE_BUFFERED]:
        'WebSocket was closed before payload could be added to the send buffer',
    [WIKO_ERROR__RPC_SUBSCRIPTIONS__CHANNEL_CONNECTION_CLOSED]: 'WebSocket connection closed',
    [WIKO_ERROR__RPC_SUBSCRIPTIONS__CHANNEL_FAILED_TO_CONNECT]: 'WebSocket failed to connect',
    [WIKO_ERROR__RPC_SUBSCRIPTIONS__EXPECTED_SERVER_SUBSCRIPTION_ID]:
        'Failed to obtain a subscription id from the server',
    [WIKO_ERROR__RPC__API_PLAN_MISSING_FOR_RPC_METHOD]: 'Could not find an API plan for RPC method: `$method`',
    [WIKO_ERROR__RPC__INTEGER_OVERFLOW]:
        'The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was ' +
        '`$value`. This number is unsafe for use with the Wiko JSON-RPC because it exceeds ' +
        '`Number.MAX_SAFE_INTEGER`.',
    [WIKO_ERROR__RPC__TRANSPORT_HTTP_ERROR]: 'HTTP error ($statusCode): $message',
    [WIKO_ERROR__RPC__TRANSPORT_HTTP_HEADER_FORBIDDEN]:
        'HTTP header(s) forbidden: $headers. Learn more at ' +
        'https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.',
    [WIKO_ERROR__SIGNER__ADDRESS_CANNOT_HAVE_MULTIPLE_SIGNERS]:
        'Multiple distinct signers were identified for address `$address`. Please ensure that ' +
        'you are using the same signer instance for each address.',
    [WIKO_ERROR__SIGNER__EXPECTED_KEY_PAIR_SIGNER]:
        'The provided value does not implement the `KeyPairSigner` interface',
    [WIKO_ERROR__SIGNER__EXPECTED_MESSAGE_MODIFYING_SIGNER]:
        'The provided value does not implement the `MessageModifyingSigner` interface',
    [WIKO_ERROR__SIGNER__EXPECTED_MESSAGE_PARTIAL_SIGNER]:
        'The provided value does not implement the `MessagePartialSigner` interface',
    [WIKO_ERROR__SIGNER__EXPECTED_MESSAGE_SIGNER]:
        'The provided value does not implement any of the `MessageSigner` interfaces',
    [WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_MODIFYING_SIGNER]:
        'The provided value does not implement the `TransactionModifyingSigner` interface',
    [WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_PARTIAL_SIGNER]:
        'The provided value does not implement the `TransactionPartialSigner` interface',
    [WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_SENDING_SIGNER]:
        'The provided value does not implement the `TransactionSendingSigner` interface',
    [WIKO_ERROR__SIGNER__EXPECTED_TRANSACTION_SIGNER]:
        'The provided value does not implement any of the `TransactionSigner` interfaces',
    [WIKO_ERROR__SIGNER__TRANSACTION_CANNOT_HAVE_MULTIPLE_SENDING_SIGNERS]:
        'More than one `TransactionSendingSigner` was identified.',
    [WIKO_ERROR__SIGNER__TRANSACTION_SENDING_SIGNER_MISSING]:
        'No `TransactionSendingSigner` was identified. Please provide a valid ' +
        '`ITransactionWithSingleSendingSigner` transaction.',
    [WIKO_ERROR__SIGNER__WALLET_MULTISIGN_UNIMPLEMENTED]:
        'Wallet account signers do not support signing multiple messages/transactions in a single operation',
    [WIKO_ERROR__SUBTLE_CRYPTO__CANNOT_EXPORT_NON_EXTRACTABLE_KEY]: 'Cannot export a non-extractable key.',
    [WIKO_ERROR__SUBTLE_CRYPTO__DIGEST_UNIMPLEMENTED]: 'No digest implementation could be found.',
    [WIKO_ERROR__SUBTLE_CRYPTO__DISALLOWED_IN_INSECURE_CONTEXT]:
        'Cryptographic operations are only allowed in secure browser contexts. Read more ' +
        'here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.',
    [WIKO_ERROR__SUBTLE_CRYPTO__ED25519_ALGORITHM_UNIMPLEMENTED]:
        'This runtime does not support the generation of Ed25519 key pairs.\n\nInstall ' +
        '@wiko/webcrypto-ed25519-polyfill and call its `install` function before generating keys in ' +
        'environments that do not support Ed25519.\n\nFor a list of runtimes that ' +
        'currently support Ed25519 operations, visit ' +
        'https://github.com/WICG/webcrypto-secure-curves/issues/20.',
    [WIKO_ERROR__SUBTLE_CRYPTO__EXPORT_FUNCTION_UNIMPLEMENTED]:
        'No signature verification implementation could be found.',
    [WIKO_ERROR__SUBTLE_CRYPTO__GENERATE_FUNCTION_UNIMPLEMENTED]: 'No key generation implementation could be found.',
    [WIKO_ERROR__SUBTLE_CRYPTO__SIGN_FUNCTION_UNIMPLEMENTED]: 'No signing implementation could be found.',
    [WIKO_ERROR__SUBTLE_CRYPTO__VERIFY_FUNCTION_UNIMPLEMENTED]: 'No key export implementation could be found.',
    [WIKO_ERROR__TIMESTAMP_OUT_OF_RANGE]:
        'Timestamp value must be in the range [-(2n ** 63n), (2n ** 63n) - 1]. `$value` given',
    [WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_BORROW_OUTSTANDING]:
        'Transaction processing left an account with an outstanding borrowed reference',
    [WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_IN_USE]: 'Account in use',
    [WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_LOADED_TWICE]: 'Account loaded twice',
    [WIKO_ERROR__TRANSACTION_ERROR__ACCOUNT_NOT_FOUND]:
        'Attempt to debit an account but found no record of a prior credit.',
    [WIKO_ERROR__TRANSACTION_ERROR__ADDRESS_LOOKUP_TABLE_NOT_FOUND]:
        "Transaction loads an address table account that doesn't exist",
    [WIKO_ERROR__TRANSACTION_ERROR__ALREADY_PROCESSED]: 'This transaction has already been processed',
    [WIKO_ERROR__TRANSACTION_ERROR__BLOCKHASH_NOT_FOUND]: 'Blockhash not found',
    [WIKO_ERROR__TRANSACTION_ERROR__CALL_CHAIN_TOO_DEEP]: 'Loader call chain is too deep',
    [WIKO_ERROR__TRANSACTION_ERROR__CLUSTER_MAINTENANCE]:
        'Transactions are currently disabled due to cluster maintenance',
    [WIKO_ERROR__TRANSACTION_ERROR__DUPLICATE_INSTRUCTION]:
        'Transaction contains a duplicate instruction ($index) that is not allowed',
    [WIKO_ERROR__TRANSACTION_ERROR__INSUFFICIENT_FUNDS_FOR_FEE]: 'Insufficient funds for fee',
    [WIKO_ERROR__TRANSACTION_ERROR__INSUFFICIENT_FUNDS_FOR_RENT]:
        'Transaction results in an account ($accountIndex) with insufficient funds for rent',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_ACCOUNT_FOR_FEE]: 'This account may not be used to pay transaction fees',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_ACCOUNT_INDEX]: 'Transaction contains an invalid account reference',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_ADDRESS_LOOKUP_TABLE_DATA]:
        'Transaction loads an address table account with invalid data',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_ADDRESS_LOOKUP_TABLE_INDEX]:
        'Transaction address table lookup uses an invalid index',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_ADDRESS_LOOKUP_TABLE_OWNER]:
        'Transaction loads an address table account with an invalid owner',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_LOADED_ACCOUNTS_DATA_SIZE_LIMIT]:
        'LoadedAccountsDataSizeLimit set for transaction must be greater than 0.',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_PROGRAM_FOR_EXECUTION]:
        'This program may not be used for executing instructions',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_RENT_PAYING_ACCOUNT]:
        'Transaction leaves an account with a lower balance than rent-exempt minimum',
    [WIKO_ERROR__TRANSACTION_ERROR__INVALID_WRITABLE_ACCOUNT]:
        'Transaction loads a writable account that cannot be written',
    [WIKO_ERROR__TRANSACTION_ERROR__MAX_LOADED_ACCOUNTS_DATA_SIZE_EXCEEDED]:
        'Transaction exceeded max loaded accounts data size cap',
    [WIKO_ERROR__TRANSACTION_ERROR__MISSING_SIGNATURE_FOR_FEE]:
        'Transaction requires a fee but has no signature present',
    [WIKO_ERROR__TRANSACTION_ERROR__PROGRAM_ACCOUNT_NOT_FOUND]: 'Attempt to load a program that does not exist',
    [WIKO_ERROR__TRANSACTION_ERROR__PROGRAM_EXECUTION_TEMPORARILY_RESTRICTED]:
        'Execution of the program referenced by account at index $accountIndex is temporarily restricted.',
    [WIKO_ERROR__TRANSACTION_ERROR__RESANITIZATION_NEEDED]: 'ResanitizationNeeded',
    [WIKO_ERROR__TRANSACTION_ERROR__SANITIZE_FAILURE]: 'Transaction failed to sanitize accounts offsets correctly',
    [WIKO_ERROR__TRANSACTION_ERROR__SIGNATURE_FAILURE]: 'Transaction did not pass signature verification',
    [WIKO_ERROR__TRANSACTION_ERROR__TOO_MANY_ACCOUNT_LOCKS]: 'Transaction locked too many accounts',
    [WIKO_ERROR__TRANSACTION_ERROR__UNBALANCED_TRANSACTION]:
        'Sum of account balances before and after transaction do not match',
    [WIKO_ERROR__TRANSACTION_ERROR__UNKNOWN]: 'The transaction failed with the error `$errorName`',
    [WIKO_ERROR__TRANSACTION_ERROR__UNSUPPORTED_VERSION]: 'Transaction version is unsupported',
    [WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_ACCOUNT_DATA_BLOCK_LIMIT]:
        'Transaction would exceed account data limit within the block',
    [WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_ACCOUNT_DATA_TOTAL_LIMIT]:
        'Transaction would exceed total account data limit',
    [WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_MAX_ACCOUNT_COST_LIMIT]:
        'Transaction would exceed max account limit within the block',
    [WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_MAX_BLOCK_COST_LIMIT]: 'Transaction would exceed max Block Cost Limit',
    [WIKO_ERROR__TRANSACTION_ERROR__WOULD_EXCEED_MAX_VOTE_COST_LIMIT]: 'Transaction would exceed max Vote Cost Limit',
    [WIKO_ERROR__TRANSACTION__ADDRESSES_CANNOT_SIGN_TRANSACTION]:
        'Attempted to sign a transaction with an address that is not a signer for it',
    [WIKO_ERROR__TRANSACTION__ADDRESS_MISSING]: 'Transaction is missing an address at index: $index.',
    [WIKO_ERROR__TRANSACTION__CANNOT_ENCODE_WITH_EMPTY_SIGNATURES]:
        'Transaction has no expected signers therefore it cannot be encoded',
    [WIKO_ERROR__TRANSACTION__EXPECTED_BLOCKHASH_LIFETIME]: 'Transaction does not have a blockhash lifetime',
    [WIKO_ERROR__TRANSACTION__EXPECTED_NONCE_LIFETIME]: 'Transaction is not a durable nonce transaction',
    [WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_ADDRESS_LOOKUP_TABLE_CONTENTS_MISSING]:
        'Contents of these address lookup tables unknown: $lookupTableAddresses',
    [WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_ADDRESS_LOOKUP_TABLE_INDEX_OUT_OF_RANGE]:
        'Lookup of address at index $highestRequestedIndex failed for lookup table ' +
        '`$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table ' +
        'may have been extended since its contents were retrieved',
    [WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_FEE_PAYER_MISSING]: 'No fee payer set in CompiledTransaction',
    [WIKO_ERROR__TRANSACTION__FAILED_TO_DECOMPILE_INSTRUCTION_PROGRAM_ADDRESS_NOT_FOUND]:
        'Could not find program address at index $index',
    [WIKO_ERROR__TRANSACTION__FAILED_TO_ESTIMATE_COMPUTE_LIMIT]:
        'Failed to estimate the compute unit consumption for this transaction message. This is ' +
        'likely because simulating the transaction failed. Inspect the `cause` property of this ' +
        'error to learn more',
    [WIKO_ERROR__TRANSACTION__FAILED_WHEN_SIMULATING_TO_ESTIMATE_COMPUTE_LIMIT]:
        'Transaction failed when it was simulated in order to estimate the compute unit consumption. ' +
        'The compute unit estimate provided is for a transaction that failed when simulated and may not ' +
        'be representative of the compute units this transaction would consume if successful. Inspect the ' +
        '`cause` property of this error to learn more',
    [WIKO_ERROR__TRANSACTION__FEE_PAYER_MISSING]: 'Transaction is missing a fee payer.',
    [WIKO_ERROR__TRANSACTION__FEE_PAYER_SIGNATURE_MISSING]:
        "Could not determine this transaction's signature. Make sure that the transaction has " +
        'been signed by its fee payer.',
    [WIKO_ERROR__TRANSACTION__INVALID_NONCE_TRANSACTION_FIRST_INSTRUCTION_MUST_BE_ADVANCE_NONCE]:
        'Transaction first instruction is not advance nonce account instruction.',
    [WIKO_ERROR__TRANSACTION__INVALID_NONCE_TRANSACTION_INSTRUCTIONS_MISSING]:
        'Transaction with no instructions cannot be durable nonce transaction.',
    [WIKO_ERROR__TRANSACTION__INVOKED_PROGRAMS_CANNOT_PAY_FEES]:
        'This transaction includes an address (`$programAddress`) which is both ' +
        'invoked and set as the fee payer. Program addresses may not pay fees',
    [WIKO_ERROR__TRANSACTION__INVOKED_PROGRAMS_MUST_NOT_BE_WRITABLE]:
        'This transaction includes an address (`$programAddress`) which is both invoked and ' +
        'marked writable. Program addresses may not be writable',
    [WIKO_ERROR__TRANSACTION__MESSAGE_SIGNATURES_MISMATCH]:
        'The transaction message expected the transaction to have $signerAddressesLength signatures, got $signaturesLength.',
    [WIKO_ERROR__TRANSACTION__SIGNATURES_MISSING]: 'Transaction is missing signatures for addresses: $addresses.',
    [WIKO_ERROR__TRANSACTION__VERSION_NUMBER_OUT_OF_RANGE]:
        'Transaction version must be in the range [0, 127]. `$actualVersion` given',
};
